export const siteAvailableLangs = ['fr', 'es', 'de', 'en', 'ru', 'pt'];

export type SiteUrl = Record<(typeof siteAvailableLangs)[number], string>;

export type SiteUrls = {
  base_url: string;
  cookies: SiteUrl;
  privacy: SiteUrl;
  terms_of_sales: SiteUrl;
  terms_of_use: SiteUrl;
};

export type GetSiteUrls = (key: Exclude<keyof SiteUrls, 'base_url'>) => string | undefined;

export type AppsUrls = {
  recruiter_account: string;
  report_manager: string;
  auth_url: string;
  admin_account: string;
  manager_account: string;
  candidate_reports: string;
  help: string;
};

export type GetAppsUrls = (key: keyof AppsUrls) => string;
